<template><CircleContent /></template>
<script setup lang="ts">
import CircleContent from '../circle-content/index.vue'
defineOptions({ name: 'BossCircleWhitepaper' })
</script>
